import { render } from "./Lotto5.vue?vue&type=template&id=04a95418&scoped=true"
import script from "./Lotto5.vue?vue&type=script&lang=js"
export * from "./Lotto5.vue?vue&type=script&lang=js"

import "./Lotto5.vue?vue&type=style&index=0&id=04a95418&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a95418"]])

export default __exports__